export function getValueByPath(item, path) {
    if (!item || !path) return undefined;
  
    return path.split('.').reduce((obj, key) => {
        if (obj == null) return undefined;
        return obj[key];
    }, item);
}
  
export function toOption(value) {
    return {
        value,
        label: formatOptionLabel(value),
    };
}
  
export function formatOptionLabel(value) {
    if (value == null || value === '') return '';
  
    return String(value)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
}
  
export function buildDynamicOptionsFromFilters(data = [], filterDefs = [], existingOptions = {}) {
    const result = { ...existingOptions };
  
    filterDefs.forEach((def) => {
        if (def.type !== 'multiSelect') return;
    
        const optionKey = def.optionKey || def.id;
    
        if (Array.isArray(result[optionKey]) && result[optionKey].length) {
            return;
        }
    
        if (!def.field) {
            result[optionKey] = [];
            return;
        }
    
        const values = new Set();
    
        data.forEach((item) => {
            const value = getValueByPath(item, def.field);
    
            if (Array.isArray(value)) {
                value.forEach((v) => {
                    if (v !== undefined && v !== null && v !== '') values.add(v);
                });
            } else if (value !== undefined && value !== null && value !== '') {
                values.add(value);
            }
        });
    
        result[optionKey] = Array.from(values)
            .sort((a, b) => String(a).localeCompare(String(b)))
            .map(toOption);
    });
  
    return result;
}
  
export function applyDynamicReportFilters(data = [], filters = {}, filterDefs = []) {
    return data.filter((item) =>
        filterDefs.every((def) => itemPassesFilter(item, filters, def))
    );
}
  
export function itemPassesFilter(item, filters, def) {
    if (!def || def.type === 'dateRange') return true;
  
    if (def.type === 'numberRange') {
        return itemPassesNumberRange(item, filters, def);
    }
  
    const filterValue = filters[def.id];
  
    if (
      filterValue === undefined ||
      filterValue === null ||
      filterValue === '' ||
      (Array.isArray(filterValue) && filterValue.length === 0)
    ) {
        return true;
    }
  
    const itemValue = getValueByPath(item, def.field || def.id);
  
    switch (def.operator || def.type) {
        case 'in':
        case 'multiSelect':
            return valueMatchesMultiSelect(itemValue, filterValue);
    
        case 'equals':
            return itemValue === filterValue;
    
        case 'contains':
            return String(itemValue || '')
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
    
        default:
            return true;
    }
}
  
function itemPassesNumberRange(item, filters, def) {
    const itemValue = Number(getValueByPath(item, def.field));
  
    if (Number.isNaN(itemValue)) return true;
  
    const minRaw = filters[def.minKey];
    const maxRaw = filters[def.maxKey];
  
    if (minRaw !== undefined && minRaw !== '') {
        const min = Number(minRaw);
        if (!Number.isNaN(min) && itemValue < min) return false;
    }
  
    if (maxRaw !== undefined && maxRaw !== '') {
        const max = Number(maxRaw);
        if (!Number.isNaN(max) && itemValue > max) return false;
    }
  
    return true;
}
  
function valueMatchesMultiSelect(itemValue, selectedValues = []) {
    if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
        return true;
    }
  
    if (Array.isArray(itemValue)) {
        return itemValue.some((v) => selectedValues.includes(v));
    }
  
    return selectedValues.includes(itemValue);
}